module.exports = __webpack_public_path__ + "static/bnr_wide-67f7ed858b96cf1dbfe2190af5759362.webp";